import React from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from '../../../utility/helper';

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
}));

const DraftCombineTransportationAccordianCard = (props) =>
{
    const classess = useStyles();
    const { classes, item } = props;
    const TransportationInfo = item.actualData;

    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: 'none' }}>
                <CardContent className={classess.cardContent}>
                    {/* <Box className={classes.rowContent}> */}
                    <Box sx={{display:'flex',flexDirection:'row'}}>
                        {props.enduser ? null :
                            <>
                            { TransportationInfo.transportType === 'air' && TransportationInfo.totalPassengers !== null ? (
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                        No Of People Travelling
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {TransportationInfo.totalPassengers}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null} 
                                {TransportationInfo.tripInfoType === "departure" ? <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                           {TransportationInfo.transportType === 'air' ?"Date/Time" :"Start Date"}
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}>
                                            <span>
                                                {Helper.FormatDateTime(
                                                    TransportationInfo.fromDate
                                                )}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box> : null}
                                {TransportationInfo.tripInfoType === "arrival" ? <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                        {TransportationInfo.transportType === 'air' ?"Date/Time" :"DropOff Date"}
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}>
                                            <span>
                                                {Helper.FormatDateTime(
                                                    TransportationInfo.toDate
                                                )}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box> : null}
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            {TransportationInfo.transportType === 'air' ? 'Departure Airport' : 'Pickup Location'}

                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {TransportationInfo.fromLocation}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            {TransportationInfo.transportType === 'air' ? 'Arrival Airport' : 'Dropff Location'}
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            // flexGrow={1}
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>{TransportationInfo.toLocation}</span>
                                        </Typography>
                                    </Box>
                                </Box>
                            </>}
                        {TransportationInfo.passangerEmail ? (
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Email
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {TransportationInfo.passangerEmail}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                        ) : null}

                        {TransportationInfo.passangerContact ? (
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Contact
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {
                                                TransportationInfo.passangerContact
                                            }
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                        ) : null}
                        </Box>
                        {(TransportationInfo.transportType === 'ground' || TransportationInfo.transitType === 'ground') &&TransportationInfo.lastModifiedDate!=="0001-01-01T00:00:00" 
                       && TransportationInfo.lastModifiedDate !== null ? (
                        <Box className={classes.rowContent}>
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Modified Date
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {
                                                Helper.FormatDateTime(TransportationInfo.lastModifiedDate)
                                            }
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                            </Box>
                        ) : null}
                    {(TransportationInfo.transportType == 'air' || TransportationInfo.transitType == 'Air') ? (
                        <Box sx={{ mt: 1,display:'flex',flexDirection:'row' }}>
                            {TransportationInfo.airline != '' ? (
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Airline
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {TransportationInfo.airline}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                            {TransportationInfo.passangerDOB && TransportationInfo.passangerDOB !== null ? (
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            DOB
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {Helper.FormatDate(TransportationInfo.passangerDOB)}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                            {TransportationInfo.flightNo != '' ? (
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            {TransportationInfo.isPrivate ? "Tail No" : "Flight No"}
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {TransportationInfo.flightNo}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                            {TransportationInfo.comments ? (
                                <Box
                                    sx={{
                                        width: '180px',
                                        flexBasis: '180px',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'left',
                                            alignItems: 'left',
                                        }}>
                                        <Typography
                                            variant="h4"
                                            fontSize={12}
                                            fontWeight={500}
                                            color="primary">
                                            Comments
                                        </Typography>
                                        <Typography
                                            variant="h4"
                                            fontSize={14}
                                            fontWeight={400}
                                            style={{ wordWrap: 'break-word' }}>
                                            <span>
                                                {TransportationInfo.comments}
                                            </span>
                                        </Typography>
                                    </Box>
                                </Box>
                            ) : null}
                            {TransportationInfo.lastModifiedDate!=="0001-01-01T00:00:00" 
                       && TransportationInfo.lastModifiedDate !== null ? (
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Modified Date
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {
                                                Helper.FormatDateTime(TransportationInfo.lastModifiedDate)
                                            }
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                        ) : null}
                            {/* <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                            </Box>
                            {[1, 2, 3].map((item) =>
                            {
                                return (
                                    <Box
                                        key={`InfoSpa_${item}`}
                                        sx={{
                                            width: '180px',
                                            flexBasis: '180px',
                                            flexGrow: 1,
                                            mb: 1,
                                        }}></Box>
                                );
                            })} */}
                        </Box>
                    ) : null}
                </CardContent>
            </Card>
        </>
    );
};

export default DraftCombineTransportationAccordianCard;
